<template>
  <div class="about">
    <page-content>
      <form @submit.prevent="onSubmit()">
        <ntm-block>
          <formly-form :form="form" :model="model" :fields="organizationFields"></formly-form>
          <button class="btn btn-success push-15">{{ $t('save') }}</button>
        </ntm-block>
      </form>
    </page-content>
  </div>
</template>

<script>
import SettingsService from '../../services/settings.service'
import formDefinition from './formDefinition'
import UserService from '@/services/user.service'
import store from '@/store'

export default {
  data () {
    return {
      model: {},
      form: {},
      organizationFields: formDefinition.organizationFields
    }
  },
  beforeRouteEnter (to, from, next) {
    SettingsService.index().then((response) => {
      next(vm => vm.setData(response.data))
    })
  },
  mounted () {
    const availableLanguages = store.state.availableLanguages.map(lang => lang.id)

    const field = this.organizationFields.find(field => field.key === 'lang')
    const availableWebsiteLanguagesField = this.organizationFields.find(field => field.key === 'availableWebsiteLanguages')

    field.options = availableLanguages
    availableWebsiteLanguagesField.options = availableLanguages

    this.organizationFields[6].templateOptions.uuid = this.model.uuid
    this.organizationFields[6].templateOptions.assetType = 'settings'

    const timezoneSelect = this.organizationFields.find((field) => field.key === 'timezone')

    timezoneSelect.options = this.model.timezones
  },
  methods: {
    generateUserTvCode () {
      SettingsService.generateUserTvCode().then((res) => {
        console.log(res)
        this.model.tvCode = res.data.toString()
      })
    },
    setData (data) {
      this.model = data
    },
    onSubmit () {
      SettingsService.storeOrganization(this.model).then(async () => {
        await UserService.getUser().then((response) => {
          store.commit('currentUser', response.data)
        })
        this.form.$errors = {}
        await this.$store.dispatch('getClient')
        this.$store.commit('loaded')
      }).catch((err) => {
        this.form.$errors = err.response.data.errors
      })
    }
  }
}
</script>
